module.exports = __webpack_public_path__ + "img/duree3.3a289b00.svg";